// extracted by mini-css-extract-plugin
module.exports = {"myText":"AddQty_myText__3Ajga"};